// @file Network requests related to wall RSS feed from surface

import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { HashId, WallRssFeedUrlResponse } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class WallFeedApi extends FetchableObject {
  private static readonly API_VERSION = 9

  /**
   * Fetches the RSS feed URL for a given wall
   * @param wallHashid - The hashid of the wall
   * @returns Promise containing the RSS feed URL
   */
  public static async getRssFeedUrl(wallHashid: HashId): Promise<JsonAPIResponse<WallRssFeedUrlResponse>> {
    const url = `/api/${this.API_VERSION}/walls/${wallHashid}/rss-feed-url`
    return await fetchJson(url, {
      method: HTTPMethod.get,
    })
  }
}

export { WallFeedApi }
